var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMitFinalLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "url(#paint0_linear_233_9021)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3389 23.2827V37.517L39.8427 45.7927V23.2827L27.9341 16L16.3389 23.2827Z",
    fill: "#A7247A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0332 23.2827V37.517L39.5294 45.7927V23.2827L51.438 16L63.0332 23.2827Z",
    fill: "#BAE132"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0898 40.069C17.033 39.5431 14.1826 39.9421 12.5306 40.4554L12 38.5499C13.8996 37.9597 17.0349 37.5311 20.392 38.1087C23.7636 38.6887 27.4105 40.2947 30.2213 43.8293L28.7815 45.1068C26.3274 42.0208 23.1322 40.5924 20.0898 40.069Z",
    fill: "#FC9127"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0141 56.2249L23.7464 60.5283L22.7217 58.863L28.9894 54.5596L30.0141 56.2249Z",
    fill: "#FC9127"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.9102 40.0693C62.967 39.5434 65.8174 39.9423 67.4694 40.4556L68 38.5501C66.1004 37.96 62.9651 37.5313 59.608 38.1089C56.2364 38.6889 52.5895 40.295 49.7787 43.8296L51.2185 45.1071C53.6726 42.021 56.8678 40.5927 59.9102 40.0693Z",
    fill: "#FC9127"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9849 56.2249L56.2526 60.5283L57.2773 58.863L51.0097 54.5596L49.9849 56.2249Z",
    fill: "#FC9127"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9336 56.5894V44.8H51.7508V56.5894L39.6834 63.9998L27.9336 56.5894Z",
    fill: "#FD8F23"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.7508 49.7645H27.9336V47.7783H51.7508V49.7645Z",
    fill: "#36535C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.7508 54.3993H27.9336V52.4131H51.7508V54.3993Z",
    fill: "#36535C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9336 42.2658V45.462H51.7508V42.2658C49.9865 40.2416 45.201 36.1931 40.173 36.1931C35.1449 36.1931 29.9184 40.2416 27.9336 42.2658Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6687 33.8751H30.4404V31.8889H34.7333L37.8277 37.3365L36.2153 38.3584L33.6687 33.8751Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.3293 33.8751H49.5576V31.8889H45.2647L42.1704 37.3365L43.7827 38.3584L46.3293 33.8751Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9621 40.8288C37.9621 41.5601 37.4009 42.1529 36.7086 42.1529C36.0163 42.1529 35.4551 41.5601 35.4551 40.8288C35.4551 40.0975 36.0163 39.5046 36.7086 39.5046C37.4009 39.5046 37.9621 40.0975 37.9621 40.8288Z",
    fill: "#616163"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6038 40.8288C43.6038 41.5601 43.0425 42.1529 42.3502 42.1529C41.6579 42.1529 41.0967 41.5601 41.0967 40.8288C41.0967 40.0975 41.6579 39.5046 42.3502 39.5046C43.0425 39.5046 43.6038 40.0975 43.6038 40.8288Z",
    fill: "#616163"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_233_9021",
    x1: 0,
    y1: 0,
    x2: 95.844,
    y2: 30.9753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF1EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMitFinalLogo);
export default __webpack_public_path__ + "static/media/mit_final_logo.ca21ed684c64d6365ae7266359f8d919.svg";
export { ForwardRef as ReactComponent };